import * as React from "react";

function IconREATeam(props) {
  return (
    <svg width={72} height={72} fill="none" {...props}>
  <circle
    cx={35.625}
    cy={36.375}
    r={34.875}
    fill="#499792"
  />
  <circle
    cx={35.625}
    cy={36.375}
    r={34.375}
    stroke="#fff"
    strokeOpacity={0.16}
  />
  <g clipPath="url(#prefix__clip0_1726_1351)" fill="#fff">
    <path d="M29.867 37.099c1.301-.139 3.131 1.398 5.025 1.398 2.313 0 4.124-1.487 5.235-1.398 5.741.453 7.117 4.85 6.985 5.097C44.794 46.487 40.191 49 34.892 49c-5.202 0-9.73-2.405-12.09-6.567-.23-.412 1.725-4.771 7.065-5.334z" />
    <path d="M23.238 34.55c1.922.204 3.19 1.14 3.928 2.006-4.506 1.567-5.816 5.298-5.802 5.866-.486.068-.985.102-1.492.102-3.55 0-6.633-1.684-8.187-4.559-.088-.166.834-3.11 4.68-3.414.32-.026.728.144 1.211.346.64.267 1.413.59 2.296.59.658 0 1.305-.278 1.897-.531.549-.236 1.05-.45 1.47-.405zM46.76 34.55c.42-.044.921.17 1.47.406.591.253 1.239.53 1.897.531.883 0 1.656-.323 2.296-.59.484-.202.89-.372 1.211-.347 3.846.304 4.768 3.249 4.68 3.415-1.553 2.875-4.637 4.559-8.187 4.559-.508 0-1.006-.035-1.491-.102.013-.567-1.297-4.299-5.802-5.866.737-.866 2.005-1.803 3.927-2.006zM34.953 22c4.032 0 7.3 3.2 7.3 7.148 0 3.948-3.268 7.147-7.3 7.147-4.033 0-7.302-3.2-7.302-7.147 0-3.948 3.27-7.148 7.302-7.148zM19.831 24.435c2.702 0 4.892 2.144 4.892 4.789 0 2.645-2.19 4.789-4.892 4.789-2.701 0-4.892-2.144-4.892-4.79 0-2.644 2.19-4.788 4.892-4.788zM50.168 24.435c2.702 0 4.892 2.144 4.892 4.789 0 2.644-2.19 4.789-4.892 4.789-2.701 0-4.891-2.144-4.891-4.79 0-2.644 2.19-4.788 4.891-4.788z" />
  </g>
  <defs>
    <clipPath id="prefix__clip0_1726_1351">
      <path fill="#fff" transform="translate(11 11)" d="M0 0h48v48H0z" />
    </clipPath>
  </defs>
</svg>




  );
}

const MemoIconREATeam = React.memo(IconREATeam);
export default MemoIconREATeam;
